
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Colby S.',
      role: 'High School XC/TF',
      image: 'https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/0e9141ff95c957869041155cb1b768f8.jpeg',
      quote: 'Coach Jakob helped me drop my 5K from the high 19s to the low 17s in one year, earning 8th at PIAA District 2 and qualifying for states as a sophomore through personalized training and consistent motivation.',
      result: '5K PR: 17:26 | 1x PIAA State Qualifier'
    },
    {
      name: 'Corey D.',
      role: 'Recreational Runner',
      image: 'https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/4d6177b4a68b857ebb533b01f07934c4.jpeg',
      quote: 'Coach Jakob helped me drop time in both my 5K and 10K through structured, engaging training focused on hills, consistency, and breathing. He tailors workouts to specific goals and pushes athletes to reach their full potential. I highly recommend him to runners of all levels.',
      result: '5k PR: 23:36'
    },
    {
      name: 'Derek R.',
      role: 'Recreational Runner | Amateur Boxer',
      image: 'https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/190ae9033a9495d82777027ae1d9fc05.jpeg',
      quote: 'Coach Jakob completely changed my relationship with running. I went from being out of shape and struggling to finish 2 miles to consistently completing 10–15 mile long runs every week along with my completing my first Half and Full Marathon. His encouragement, smart training, and constant support helped me build confidence, endurance, and a love for running I never thought I\'d have.',
      result: '5k PR: 20:03 & 1st AG, 10k PR: 43:37 & 2nd AG | Half & Full Marathon Finisher'
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 font-serif">
            What Runners Are Saying
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Real results from real runners who trusted the process
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[#F9F8F6] rounded-xl sm:rounded-2xl p-5 sm:p-6 lg:p-8 relative"
            >
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center absolute top-4 right-4 sm:top-6 sm:right-6">
                <i className="ri-double-quotes-l text-3xl sm:text-4xl text-[#E8744F]/20"></i>
              </div>
              
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <h4 className="font-bold text-gray-900 text-sm sm:text-base">{testimonial.name}</h4>
                  <p className="text-xs sm:text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>

              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6 pr-4 sm:pr-0">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-2 pt-3 sm:pt-4 border-t border-gray-200">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                  <i className="ri-trophy-line text-base sm:text-lg text-[#E8744F]"></i>
                </div>
                <span className="text-xs sm:text-sm font-semibold text-[#E8744F]">
                  {testimonial.result}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
